import React from 'react'
import { useWebSocket } from '../../hooks/useWebSocket'
import { useAuth } from '../../contexts/AuthContext'
import { Badge } from '../ui'

export const Header: React.FC = () => {
  const { connected } = useWebSocket()
  const { user, logout } = useAuth()

  return (
    <header className="bg-gradient-to-r from-sky-400 via-blue-500 to-blue-600 shadow-lg relative z-30">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4 lg:py-6">
          {/* Logo and Title - Adjusted for sidebar layout */}
          <div className="flex items-center space-x-4 ml-12 lg:ml-0">
            <div className="flex-shrink-0">
              <img 
                src="/dynamics-logo.webp" 
                alt="Dynamics G-Ex Logo" 
                className="h-10 lg:h-12 w-auto"
              />
            </div>
            <div className="flex-shrink-0">
              <h1 className="text-xl lg:text-2xl font-bold text-white drop-shadow-sm">
                Dynamics G-Ex Sales Hub
              </h1>
            </div>
          </div>



          {/* User Info and Logout */}
          <div className="flex items-center space-x-4">
            {user && (
              <div className="flex items-center space-x-3">
                <div className="text-right">
                  <div className="text-sm font-medium text-white drop-shadow-sm">{user.name}</div>
                  <Badge variant={connected ? 'success' : 'error'} size="sm">
                    {connected ? 'Connected' : 'Disconnected'}
                  </Badge>
                </div>
                <button
                  onClick={logout}
                  className="inline-flex items-center px-3 py-2 border border-white/20 shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-white/10 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white/50 transition-colors duration-200"
                >
                  <svg className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}

 